/**
 * Automation Status Tracking Session
 */
import type { useI18n } from '@affine/i18n';

import type { TutorialSession } from '../../types';

type I18n = ReturnType<typeof useI18n>;

export function createStatusTrackingSession(t: I18n): TutorialSession {
  return {
    id: 'automation:statusTracking',
    context: {
      targetAudience: 'technical',
      category: 'automation',
      tab: 'input',
    },
    steps: [
      {
        targetSelector: '[data-section="status-tracking"]',
        title: t['com.streamlain.streamlain.input.status-tracking'](),
        content:
          t['com.streamlain.streamlain.input.status-tracking-subtitle'](),
        animation: 'pulse',
      },
    ],
  };
}
